import { View } from 'react-native';
import React, { useEffect, useRef, useState, memo } from 'react';
import { StyleSheet } from 'react-native-unistyles';

const DEFAULT_HEIGHT = 600;

function GivingOnboardingWebView({ url, onMessage, style }) {
    const iframeRef = useRef(null);
    const [contentHeight, setContentHeight] = useState(null);

    useEffect(() => {
        const receiveMessage = (event) => {
            if (event.origin !== window.location.origin) return;
            const { type, detail } = event.data || {};

            if (type === 'rainforest_frame_height') {
                const h = detail && typeof detail.height === 'number' ? detail.height : null;
                if (h && h > 0) setContentHeight(h);
                return;
            }

            onMessage?.(event.data);
        };

        window.addEventListener('message', receiveMessage);
        return () => window.removeEventListener('message', receiveMessage);
    }, [onMessage]);

    const resolvedHeight = contentHeight ?? style?.height ?? DEFAULT_HEIGHT;

    return (
        <View style={[styles.container, style, { height: resolvedHeight }]} testID="giving-onboarding-webview">
            <iframe
                ref={iframeRef}
                src={url}
                title="Onboarding"
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    width: '100%',
                    height: '100%',
                    border: 'none',
                    backgroundColor: 'transparent',
                }}
            />
        </View>
    );
}

const styles = StyleSheet.create(() => ({
    container: {
        overflow: 'hidden',
        backgroundColor: 'transparent',
        position: 'relative',
    },
}));

export default memo(GivingOnboardingWebView);
